import { createProductComparisonSummary } from './functions/createProductComparisonSummary';
import { createProductContextualButton } from './functions/createProductContextualButton';
import { initializeProductContextualButtons } from './functions/initializeProductContextualButtons';
import { createProductListCarousel } from './functions/createProductListCarousel';
import { createProductPackBanner } from './functions/createProductPackBanner';
import { createProductQuestions } from './functions/createProductQuestions';
import { createSearchBanner } from './functions/createSearchBanner';
import { getProductList } from './functions/getProductList';
import { getState } from './functions/getState';
import { startFeature } from './functions/startFeature';
import { toggleProductSelection } from './functions/toggleProductSelection';

export const brilliant = {
    createProductComparisonSummary,
    createProductContextualButton,
    initializeProductContextualButtons,
    createProductListCarousel,
    createProductPackBanner,
    createProductQuestions,
    createSearchBanner,
    getProductList,
    getState,
    startFeature,
    toggleProductSelection
} as const;

window.brilliant = brilliant;
export type Brilliant = typeof brilliant;

declare global {
    interface Window {
        brilliant: Brilliant;
    }
}
